module.exports = __webpack_public_path__ + "img/personal3.7248462c.jpg";